"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthenticated = exports.AuthProvider = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var APIBase_1 = require("./APIBase");
var AuthContext = (0, react_1.createContext)({
    authenticated: false,
    lastPingResult: null,
    forcePing: function () {
        console.error('auth context not configured');
    },
    setAuthenticated: function (tf) {
        console.error('auth context not configured');
    },
});
function AuthProvider(props) {
    var _this = this;
    var _a = (0, react_1.useState)(true), authenticated = _a[0], setAuthenticated = _a[1];
    var _b = (0, react_1.useState)(null), lastPingResult = _b[0], setLastPingResult = _b[1];
    var onPing = props.onPing, pingInterval = props.pingInterval;
    var check = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onPing)
                        return [2 /*return*/];
                    return [4 /*yield*/, onPing()];
                case 1:
                    value = _a.sent();
                    setLastPingResult(value);
                    return [2 /*return*/];
            }
        });
    }); }, [onPing]);
    (0, react_1.useEffect)(function () {
        if (!onPing)
            return;
        function fx() {
            return __awaiter(this, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, check()];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        fx();
        var checker = setInterval(fx, pingInterval || 30 * 1000);
        return function () { return clearInterval(checker); };
    }, [onPing, pingInterval, check]);
    (0, react_1.useEffect)(function () {
        var sub = APIBase_1.notAuthorizedResponse.subscribe(function () {
            setAuthenticated(false);
        });
        return function () { return sub.cancel(); };
    }, []);
    var ctx = (0, react_1.useMemo)(function () { return ({ authenticated: authenticated, setAuthenticated: setAuthenticated, lastPingResult: lastPingResult, forcePing: check }); }, [authenticated, setAuthenticated, lastPingResult, check]);
    return React.createElement(AuthContext.Provider, { value: ctx }, props.children);
}
exports.AuthProvider = AuthProvider;
function useAuthenticated() {
    return (0, react_1.useContext)(AuthContext);
}
exports.useAuthenticated = useAuthenticated;
